import { request } from "../utils/request";
import { getNewEndpoint } from "../config/newEndpoint";

async function getCertificate(params) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    method: "get",
    url: `${NEW_ENDPOINT.SSL}/certificate_container`,
    params,
  });
}

async function getDetailCertificate(id) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    method: "get",
    url: `${NEW_ENDPOINT.SSL}/certificate_container/${id}`,
  });
}

async function createCertificate(data) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    method: "post",
    url: `${NEW_ENDPOINT.SSL}/certificate_container`,
    data,
  });
}

async function autoCreateCertificate(data) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    method: "post",
    url: `${NEW_ENDPOINT.SSL}/autocreatecert/http`,
    data,
  });
}

async function createAutoSSL(data) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    method: "post",
    url: `${NEW_ENDPOINT.SSL}/autocreatecert/dns`,
    data,
  });
}

async function deleteCertificate(certificateId, params) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    url: `${NEW_ENDPOINT.SSL}/certificate_container/${certificateId}`,
    method: "delete",
    params,
  });
}

async function getSecrets(id) {
  const NEW_ENDPOINT = await getNewEndpoint();
  return request({
    method: "get",
    url: `${NEW_ENDPOINT.SSL}/secrets/${id}`,
  });
}

export default {
  getCertificate,
  createCertificate,
  autoCreateCertificate,
  deleteCertificate,
  createAutoSSL,
  getDetailCertificate,
  getSecrets,
};
